import {useNavigate} from 'react-router-dom';
import StatusBadge from '../../../../../../components/statusBadge';

interface IProps {
  logo: string;
  name: string;
  data: IBrandResponse;
  onClickNavigate?: () => void;
}

const BrandCard = ({logo, name, data, onClickNavigate}: IProps) => {
  const navigate = useNavigate();

  return (
    <div
      className="flex items-center justify-between gap-3 p-3 bg-white border shadow-sm rounded-xl"
      onClick={
        onClickNavigate
          ? onClickNavigate
          : () =>
              data.status === 'accept' &&
              navigate(`brand/${data.id}`, {
                state: {
                  brandLogo: data.logo,
                  brandName: data.name,
                },
              })
      }
      style={data.status !== 'accept' ? {pointerEvents: 'none'} : undefined}
    >
      <div className="flex items-center gap-3">
        <img
          src={logo}
          alt={name}
          className="object-cover rounded-lg w-11 h-11"
        />
        <span className="line-clamp-1">{name}</span>
      </div>

      <div className="flex items-center gap-1 shrink-0">
        {data.status !== 'accept' && <StatusBadge status={data.status} />}
        {data.status === 'accept' && (
          <i className="text-gray-800 icon-nameArrow---Left-2" />
        )}
      </div>
    </div>
  );
};

export default BrandCard;
